export default __webpack_public_path__ + "static/media/cp_geo_la.25a36cc1.svg";